module.exports = __webpack_public_path__ + "img/mD-badge5-dark.e501e127.png";